import { render, staticRenderFns } from "./Appeals.vue?vue&type=template&id=4f8b6306"
import script from "./Appeals.vue?vue&type=script&lang=js"
export * from "./Appeals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports